import styled from "styled-components";

export const App = styled.div`
  background-color: ${props => props.theme.colors.background};
`;

export const Inner = styled.div`
  ${props => props.theme.gridStyles.getContainerStyles()}
`;
